import validator from 'validator';

const checkEmail = (required = true, message) => (rule, value) => {
    if (!value && !required)
        return Promise.resolve();
    if (!validator.isEmail(value)) {
        return Promise.reject(message || '邮箱格式不正确');
    }
    return Promise.resolve();
};
const checkIsBlank = (errorMsg) => (rule, value) => {
    if (value && value.trim().length > 0)
        return Promise.resolve();
    return Promise.reject(errorMsg || '不能为空');
};

export { checkEmail, checkIsBlank };
